
import React, { useState } from 'react';

import { IsModemAccess, amountFormatUse, getToken, utc_local } from '../../../helpers/Helper';
import { POST_ORDER_LIST, POST_PDF_INVOICE, POST_ORDER_GENERATE_INVOICE_LIST, POST_DELETE_ORDER, POST_UPDATE_ORDER_STATUS } from '../../../helpers/url_helper';
import { post, del } from '../../../helpers/api_helper';
import { toast } from 'react-toastify';

import ReactDOM from 'react-dom/client';
import useMounted from '../../../hooks/useMounted';
import { useNavigate } from 'react-router-dom';

import $ from 'jquery';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/dataTables.dataTables.css";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const UserRoles = (props) => {
    const navigate = useNavigate();
    const [orderId, SetOrderId] = useState('');
    const [filter_option, setFilterOption] = useState({ status: '', startDate: '', endDate: '' });
    const [orderInfo, setorderInfo] = useState(null);
    const [ButtonDisabled, SetButtonDisabled] = useState(false);
    const [orderStatus, SetOrderStatus] = useState('');
    const [editTransactionId, SetEditTransactionId] = useState('');


    useMounted(() => {
        if (!IsModemAccess('order', 'view')) {
            toast.error('Does not permission this module');
            navigate("/admin/dashboard");
        }

        get_invoice_list()
    },[navigate])

    const get_invoice_list = () => {
        const tableElement = $('#dataTableExample');
        if (tableElement.length > 0) {
            tableElement.DataTable({
                destroy: true,
                "bProcessing": true,
                "bServerSide": true,
                'searching': true,
                'stateSave': true,
                "scrollX": false,
                "sServerMethod": "POST",
                "order": [[0, 'desc']],
                columnDefs: [
                    { orderable: false, targets: [8,9] },
                    { "targets": '', "visible": false }
                ],
                "ajax": function (data, callback, settings) {
                    data.sSearch = data.search.value;
                    data.iDisplayLength = data.length;
                    data.iDisplayStart = data.start;
                    data.sSortDir_0 = (data.order.length > 0) ? data.order[0].dir : '';
                    data.iSortCol_0 = (data.order.length > 0) ? data.order[0].column : '';

                    data.status = filter_option.status;
                    data.startDate = (filter_option.startDate) ? new Date(filter_option.startDate).getTime() : '';
                    data.endDate = (filter_option.endDate) ? new Date(filter_option.endDate).getTime() : '';

                    $.ajax({
                        "url": POST_ORDER_LIST,
                        "type": "POST",
                        "data": data,
                        "headers": { 'Authorization': getToken() },
                        "error": function (xhr, status, error) {
                            if (xhr.status === 401) {
                                navigate("/logout");
                            }
                        },
                        "success": callback
                    });
                },
                "columns": [
                    { "data": "orderId" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                {utc_local(data.createdAt)}
                            </>)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                <span href="#" className='text-primary pointer' onClick={() => { window.open('/admin/users/view/' + data.userId, '_blank'); }}>{data.name} </span>
                            </>)
                        }
                    },
                    { "data": "email" },
                    { "data": "planName" },
                    { "data": "upiId" },
                    { "data": "transactionId" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                {amountFormatUse(data.amount)}
                            </>)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                <button data-bs-toggle="modal" data-bs-target="#EditModal" onClick={() => {SetOrderStatus(data.orderStatus); SetOrderId(data.orderId);}}  className={`border-0 badge ${(data.orderStatus === 'Completed') ? 'bg-success' : (data.orderStatus === 'Canceled')? 'bg-danger' : 'bg-info'}`}>{data.orderStatus}</button>
                            </>)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                {data.invoiceId <= 0 && <>
                                    {data.orderStatus === 'Pending' && <button onClick={() => { setorderInfo(data); SetEditTransactionId(data.transactionId || ''); }} data-bs-toggle="modal" data-bs-target="#orderModal" type='button' className='btn btn-sm btn-primary me-2'>Creat Invoice</button>}
                                    {IsModemAccess('order', 'delete') &&<button onClick={() => { SetOrderId(data.orderId); }} data-bs-toggle="modal" data-bs-target="#deleteModal" type='button' className='btn btn-sm text-danger'><i className="bx bx-trash-alt align-middle"></i></button>}
                                </>}
                                {data.invoiceId > 0 && <a href={`${POST_PDF_INVOICE}${data.invoiceId}`} target="_blank"  rel="noreferrer"  className={`btn btn-sm text-info`}><i className="bx bxs-file-pdf"></i></a>}
                                {data.mobileNo && <a href={`https://wa.me/91${data.mobileNo}?text=${encodeURIComponent(`🎉 *Payment Successful!*\n\nDear ${data.name},\n\n✅ Your payment of *₹${data.amount}* for *"${data.planName}"* plan has been received successfully.\n\n🚀 Your subscription is now *activated*.\n\n🙏 Thank you for choosing *Cheque Print*!\n\n🌐 Visit us: https://chequeprint.co.in/`)}`} target="_blank" rel="noreferrer" className='btn btn-sm text-success'><i className="bx bxl-whatsapp"></i></a>}
                            </>)
                        }
                    },

                ]
            });
        }
    }

    // input text change handler
    const handleInputChangeFilter = (event) => {
        setFilterOption(inputs => ({ ...filter_option, [event.target.name]: event.target.value }));
    }

    const clear = () => {
        filter_option.status = ''
        filter_option.startDate = ''
        filter_option.endDate = ''
        setFilterOption({ ...filter_option });
        get_invoice_list();
    }

    const generateInvoice = async () => {
        SetButtonDisabled(true);
        var api_res = await post(POST_ORDER_GENERATE_INVOICE_LIST, { orderId: orderInfo.orderId, transactionId: editTransactionId });
        if (api_res.status) {
            toast(api_res.message);
            get_invoice_list();
            window.$('orderModal').modal('hide');
        } else {
            toast.error(api_res.message)
        }
        SetButtonDisabled(false);
    }

    // remove user role
    const remove_row = async () => {
        var res_data = await del(POST_DELETE_ORDER + "?orderId=" + orderId);
        if (res_data.status) {
            toast(res_data.message);
            get_invoice_list();
        } else {
            toast.error(res_data.message);
        }
    }

    const handleSubmitOrderStatus = async (event) => {
        event.preventDefault();
        SetButtonDisabled(true);
        var res_data = await post(POST_UPDATE_ORDER_STATUS, {orderStatus : orderStatus,orderId : orderId});
        if (res_data.status) {
            toast(res_data.message);
            get_invoice_list();
            window.$('#EditModal').modal('hide');
        } else {
            toast.error(res_data.message);
        }
        SetButtonDisabled(false);
    }

    return (
        <>
            <div className='row'>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <div className='row mb-3'>
                                <div className='col-sm-6'>
                                    <h5 className='mt-1'>Orders </h5>
                                </div>
                                <div className='col-sm-6 text-right'>
                                </div>
                            </div>
                            <hr />
                            <div className='row mt-4 mb-3'>
                                <div className='col-sm-3 mb-3'>
                                    <DatePicker name='startDate' className='form-control'
                                        selected={filter_option.startDate} onChange={(date) => { handleInputChangeFilter({ target: { name: 'startDate', value: date } }) }}
                                        placeholderText="Start Date"
                                        dateFormat="dd/MM/yyyy"
                                        onKeyDown={(e) => e.preventDefault()}
                                    />
                                </div>
                                <div className='col-sm-3 mb-3'>
                                    <DatePicker name='endDate' className='form-control'
                                        selected={filter_option.endDate} onChange={(date) => { handleInputChangeFilter({ target: { name: 'endDate', value: date } }) }}
                                        placeholderText="End Date"
                                        dateFormat="dd/MM/yyyy"
                                        onKeyDown={(e) => e.preventDefault()}
                                    />
                                </div>
                                {/* <div className='col-sm-3 mb-3'>
                                    <select name='status' className='form-control' value={filter_option.status} onChange={handleInputChangeFilter}>
                                        <option value="">All</option>
                                        <option value="Unpaid">Unpaid</option>
                                        <option value="Paid">Paid</option>
                                        <option value="Canceled">Canceled</option>
                                    </select>
                                </div> */}
                                <div className='col-sm-3 mb-3'>
                                    <button type='button' onClick={get_invoice_list} className='btn btn-primary me-3'>Apply</button>
                                    <button type='button' onClick={clear} className='btn btn-danger'>Clear</button>
                                </div>
                            </div>
                            <div className='table-responsive text-nowrap'>
                                <table id="dataTableExample" className="table table-striped">
                                    <thead>
                                        <tr>
                                            <td>Order Id</td>
                                            <td>Date</td>
                                            <td>User Name</td>
                                            <td>User Email</td>
                                            <td>Plan Name</td>
                                            <td>UPI Id</td>
                                            <td>Transaction Id</td>
                                            <td>Amount</td>
                                            <td>Status</td>
                                            <td>Action</td>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="orderModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-md" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Order Info</h5>
                            <button type="button" className="btn btn-sm close" data-bs-dismiss="modal" aria-label="Close">
                                <i className="bx bx-x"></i>
                            </button>
                        </div>
                        {orderInfo && <>
                            <div className="modal-body">
                                <div className='row'>
                                    <div className='col-sm-6 mb-3'>
                                        <b>Order Id</b>
                                        <p >{orderInfo.orderId}</p>
                                        <b>Order Date</b>
                                        <p >{utc_local(orderInfo.createdAt)}</p>
                                    </div>
                                    <div className='col-sm-6 mb-3'>
                                        <b>User Name</b>
                                        <p >{orderInfo.name}</p>
                                        <b>User Email</b>
                                        <p >{orderInfo.email}</p>
                                    </div>
                                    <div className='col-sm-6 mb-3'>
                                        <b>Plan</b>
                                        <p >{orderInfo.planName}</p>
                                        <b>UPI Id</b>
                                        <p >{orderInfo.upiId}</p>
                                    </div>
                                    <div className='col-sm-6 mb-3'>
                                        <b>Transaction Id</b>
                                        <div className='mb-2'>
                                            <input type='text' className='form-control' value={editTransactionId} onChange={(e) => SetEditTransactionId(e.target.value)} placeholder='Enter Transaction Id' />
                                        </div>
                                        <b>Amount</b>
                                        <p >{amountFormatUse(orderInfo.amount)}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                                <button onClick={generateInvoice} disabled={ButtonDisabled} data-bs-dismiss="modal" className="btn btn-primary">{ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} Generate Invoice</button>
                            </div>
                        </>}
                    </div>
                </div>
            </div>

            <div className="modal fade" id="deleteModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Confirm Delete</h5>
                            <button type="button" className="btn btn-sm close" data-bs-dismiss="modal" aria-label="Close">
                                <i className="bx bx-x"></i>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>Are you sure you want to delete this record?</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">No</button>
                            <button onClick={remove_row.bind(this)} data-bs-dismiss="modal" className="btn btn-primary">Yes</button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="EditModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-md" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Order Status</h5>
                            <button type="button" className="btn btn-sm close modal-close" data-bs-dismiss="modal" aria-label="Close">
                                <i className="bx bx-x"></i>
                            </button>
                        </div>
                        <hr className='mb-0' />
                        <div className="modal-body">
                            <div className='row'>
                                <div className='col-sm-12'>
                                    <form className="av-invalid" onSubmit={handleSubmitOrderStatus}>
                                        <div className='mb-3'>
                                            <label className="form-label text-capitalize">Status </label>
                                            <select name='orderStatus' value={orderStatus} onChange={(e) => {SetOrderStatus(e.target.value)}} className="form-control" >
                                                <option value="Pending">Pending</option>
                                                <option value="Completed">Completed</option>
                                                <option value="Canceled">Canceled</option>
                                            </select>
                                        </div>
                                        <div className='text-center pt-4'>
                                            <button disabled={ButtonDisabled} className="btn btn-primary pt-2 pb-2"> {ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} Update </button>
                                            <button type='button' data-bs-dismiss="modal" aria-label="Close" className="btn btn-danger ms-3"> Cancel</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}

export default UserRoles;